/* src/app/components/billing/reports/batch-report/batch-report.component.css */
.report-container {
  display: flex;
  margin: 16px;
  width: 100%;
}
.report-label {
  margin-bottom: 4px;
  font-weight: 600;
}
.chart-info-container {
  display: flex;
  gap: 30px;
  margin-bottom: 20px;
  width: 100%;
}
.detailed-data-container {
  width: 40%;
}
:host ::ng-deep .ant-form-item {
  margin-bottom: 16px !important;
}
.chart-summary {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-weight: 600;
}
.chart-wrapper {
  max-width: 95%;
  min-width: 50%;
}
@media (max-width: 768px) {
  .chart-wrapper {
    width: 100%;
  }
}
/*# sourceMappingURL=batch-report.component-YDOO3UBT.css.map */
